import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c409e45c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c409e45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409e45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c409e45c')) {
      api.createRecord('c409e45c', component.options)
    } else {
      api.reload('c409e45c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c409e45c&scoped=true&", function () {
      api.rerender('c409e45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uF5OhO5PjGL6/JS/comp/GuestBox.vue"
export default component.exports